import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async usuarios(usuario) {
    const response = await api.post(API_URL + "usuarios", usuario);
    if (response.data) return response.data;
  },

  async guardaUsuario(usuario) {
    const response = await api.post(API_URL + "guardaUsuario", usuario);
    if (response.data) return response.data;
  },

  async borraUsuario(userId) {
    const response = await api.post(API_URL + "borraUsuario", userId);
    if (response.data) return response.data;
  },

  async generarClaveUsuario(usuario) {
    const response = await api.post(API_URL + "generarClaveUsuario", usuario);
    if (response.data) return response.data;
  },

  async listaRoles() {
    const response = await api.post(API_URL + "roles", null);
    if (response.data) return response.data;
  },

  async listaPermisos() {
    const response = await api.get(API_URL + "permisos");
    if (response.data) return response.data;
  },

  async exportarUsuarios() {
    const response = await api.post(API_URL + "usuarios/export", {}, { responseType: "blob",
    });
    return response;
  },
};
